module.exports = __webpack_public_path__ + "media/images/components/map-icons/contacts-map-pin-volunteer-177a12559a562166ce8264c3250a6f3c.png";